import Activities from "./activities";

export default Activities;